module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "pre2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#pre2"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("I am grateful for the invitation from William B. Eerdmans Publishing Company and the editor of their Pillar New Testament Commentary series, Don Carson, to revise and update my volume on the Letters of John written about twenty years ago. The invitation provided me with an opportunity to revise the work where appropriate in the light of significant literature produced over the last twenty years.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Following the guidelines for new volumes in the series, this commentary is based on the latest version of the New International Version (NIV 2011), and also adds an explanation of the context for each major section of text and a statement of the major theological content of each section.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I believe 1 John 3:23 is a key text in these letters: “And this is his command: to believe in the name of his Son, Jesus Christ, and to love one another as he commanded us.” It encapsulates their central message: the importance of right belief on the one hand and love for fellow believers on the other. Believers are to hold fast to the good news about Jesus Christ as it was passed down to them from those who were Jesus’s primary witnesses—the good news they received and believed when they first became believers. And they are to obey the command of Christ to love one another—a command that was passed down alongside the good news itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The message of these letters is of perennial importance, and especially so at times when the truth of the gospel is under attack and needs to be defended. The love of believers for one another needs to be more and more evident so that people will recognize that they are disciples of Jesus and be drawn to faith in him themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is my hope and prayer that this commentary will enable readers to appreciate afresh who Jesus is and encourage a determination to show practical love to their fellow believers as Jesus commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLIN")]), _vm._v(" G. K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUSE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d316fe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface002.vue
// module id = 75
// module chunks = 0